import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("th_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const COMPANY = {
  name: "Technological Horizons",
  tagline: "Υποδομές Οπτικών Ινών",
  address: "Νικολάου Πλαστήρα 17, Άγιοι Ανάργυροι",
  phone: "2104400519",
  mobile: "6937184175",
  email: "info@techorizons.gr",
  logo:
    "https://customer-assets.emergentagent.com/job_optical-solutions-2/artifacts/3j06g4bc_logo2_ultra_high_res.png",
};
